// Una cuenta con verificación en dos pasos (por ejemplo la del superadmin, si también es dueña de
// un negocio) necesita el código de 6 números para cambiar la contraseña: Supabase exige aal2.
import { supabase } from './supabase.ts';

/** Factor a verificar antes de cambiar la contraseña; null si no hace falta el código. */
export async function mfaFactorForPasswordChange(): Promise<string | null> {
  const { data } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
  if (!data || data.currentLevel === 'aal2' || data.nextLevel !== 'aal2') return null;
  const { data: factors } = await supabase.auth.mfa.listFactors();
  return factors?.all.find((f) => f.factor_type === 'totp' && f.status === 'verified')?.id ?? null;
}

export async function verifyMfaCode(factorId: string, code: string): Promise<void> {
  const digits = code.replace(/\s/g, '');
  if (!/^\d{6}$/.test(digits)) throw new Error('Escribí el código de 6 números de tu app de códigos.');
  const { error } = await supabase.auth.mfa.challengeAndVerify({ factorId, code: digits });
  if (error) throw new Error('Código incorrecto o vencido. Probá con el que aparece ahora.');
}
